/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
`

export default class HotTxtIcon extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="36.486" height="12.039" viewBox="0 0 36.486 12.039" css={Color}>
        <path id="합치기_1007" data-name="합치기 1007"
              d="M-756.523-166.867l1.935-8.879h-3.445l.7-3.159h11.064l-.7,3.159h-3.289l-1.947,8.879Zm-13.265-6.015a7.376,7.376,0,0,1,7.176-6.024c3.758,0,5.143,2.708,4.373,6.024a7.317,7.317,0,0,1-7.151,6.015C-769.161-166.867-770.547-169.552-769.788-172.882Zm4.1,0c-.3,1.337,0,2.424,1.115,2.424s1.929-1.086,2.226-2.424c.321-1.346.02-2.444-1.112-2.444C-764.565-175.326-765.363-174.228-765.684-172.882Zm-10.286,6.014.963-4.473h-2.446l-.975,4.473h-4.329l2.632-12.038h4.329l-.975,4.486h2.432l.977-4.486h4.329l-2.607,12.038Z"
              transform="translate(782.757 178.907)" fill="#798897"/>
      </svg>
    )
  }
}
